import React, { useState, useEffect } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { respondFormThunk } from '../../store/slices/public/procesoMatriculacion.slice';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';

const FormViewer = ({ isOpen, onClose, formulario, formularioId }) => {
    const dispatch = useDispatch();
    const [respuestas, setRespuestas] = useState([]);

    useEffect(() => {
        if (formulario?.questions) {
            setRespuestas(
                formulario.questions.map((q) => ({
                    questionId: q.id,   // Asumiendo que cada pregunta tiene un id único
                    respuesta: ''
                }))
            );
        }
    }, [formulario]);

    const handleInputChange = (index, value) => {
        const nuevasRespuestas = [...respuestas];
        nuevasRespuestas[index].respuesta = value;
        setRespuestas(nuevasRespuestas);
    };

    const handleSign = () => {
        Swal.fire({
            title: '¿Está seguro de que desea continuar?',
            text: 'Al dar click en el botón enviar, certifica que todas las respuestas son reales',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#9DC41A',
            cancelButtonColor: '#9ca3af',
            confirmButtonText: "Enviar",
            cancelButtonText: "Cancelar"
        }).then((result) => {
            if (result.isConfirmed) {
                const data = {
                    respuestas: respuestas, // Aquí envías todas las respuestas
                    isSubmited: true,
                };
                dispatch(respondFormThunk(formularioId, data)); // Aquí asumo que firmas el formulario
            }
        });
    };

    if (!isOpen || !formulario) return null;

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center">
            <div className="bg-white h-full mx-auto border border-gray-200 w-full max-w-2xl max-h-[90vh] rounded-lg shadow-xl p-6 relative">
                <h2 className="text-2xl font-bold text-gray-800 mb-6">{formulario?.titulo}</h2>
                <div className="text-start h-[68%] overflow-y-auto border border-gray-100 rounded-lg p-4 text-sm text-gray-700 bg-gray-50 space-y-3 mb-6">
                    {
                        formulario.questions?.map((question, index) => (
                            <div key={index} className="text-start border border-gray-100 rounded-lg p-2 text-sm text-gray-700 bg-blue-100 space-y-2">
                                <label htmlFor="">{question.textQuestion}</label>
                                <input
                                    className='w-full focus:outline-none border border-gray-100 p-2'
                                    type="text"
                                    placeholder={question.textQuestion}
                                    value={respuestas[index]?.respuesta || ''}
                                    onChange={(e) => handleInputChange(index, e.target.value)}
                                />
                            </div>
                        ))
                    }
                </div>
                {!formulario.isSubmited ? (
                    <div className='space-y-2'>
                        <button
                            disabled={respuestas.some(r => r.respuesta.trim() === '')}
                            className={`w-full py-2 px-4 rounded-md text-white font-semibold transition ${respuestas.some(r => r.respuesta.trim() === '') ? 'bg-gray-300' : 'bg-p-sky/70 hover:bg-p-sky'}`}
                            onClick={handleSign}
                        >
                            Enviar
                        </button>
                        <button
                            className="w-full py-2 px-4 rounded-md text-white font-semibold transition bg-gray-400 hover:bg-gray-500"
                            onClick={onClose}
                        >
                            Atrás
                        </button>
                    </div>
                ) : (
                    <div className='flex items-center justify-center gap-5 text-p-green'>
                        <FaCheckCircle size={50} />
                        <div className='flex flex-col text-start'>
                            <h2 className='text-xl font-semibold'>Formulario enviado</h2>
                            <p className='text-p-blue'>Muchas gracias por su tiempo.</p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FormViewer;
